// removed by extract-text-webpack-plugin
module.exports = {"complexRaceCard":"_4Ekj8LXNJTjQNbGGLxzx8","betButtons":"_3MS_Y3qbUokzc6BPTWKE-o","racersList":"_3IN4sGqbv0yNYYkcWcX6T","racersListContent":"_3ahvSa9TqiKN-SGfSjW6nC","racersColumn":"_3Di9i5f1qNY0IXQxCgvW1","button":"_23FzljcsVOkNUx-ckfM0YH","selected":"_2eIClUzX2NgeH9T79DF_6p"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/mobile/modules/racing/css/complexRacersList.css
// module id = 1007
// module chunks = 0